import React from 'react';

import { Icon, Space, Typography } from '@sravni/react-design-system';
import { Star } from '@sravni/react-icons';

import { IServiceOption } from '../../../../../interfaces/reviews';

interface IProductButtonProps {
  product: IServiceOption;
  nowrap: boolean;
}

export const ProductButton = ({ product, nowrap }: IProductButtonProps) => (
  <Space>
    <Typography.Text size={16} strong nowrap={nowrap}>
      {product.label || product.name}
    </Typography.Text>
    {product.rating > 0 && (
      <Space className={'h-ml-8'} size={2} align={'center'}>
        <Icon icon={<Star />} className={'h-color-D40'} size={16} />
        <Typography.Text size={10} className={'h-color-D40'}>
          {product.rating > 0 && product.rating.toFixed(1)}
        </Typography.Text>
      </Space>
    )}
  </Space>
);
